import {Component, Injector, ViewChild} from '@angular/core';
import {TableComponent} from "../../ui/table/table.component";
import {Order} from "../../../models/shop/order";
import {ShopBaseComponent} from "../../shop/shop-base.component";
import {OrderService} from "../../../services/order/order.service";
import * as moment from "moment";

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss']
})
export class OrdersComponent extends ShopBaseComponent {
    @ViewChild('orderList') orderList: TableComponent | undefined;
    companyId: string = localStorage.getItem('wisper_companyId') ?? '';
    userId: string = localStorage.getItem('wisper_userId') ?? '';
    userType?: string = localStorage.getItem('wisper_userGroup') ?? '';

    orderStatus: any[] = [
        { value: 'pendingPayment', name: 'In attesa di pagamento' },
        { value: 'paid', name: 'Pagato' },
        { value: 'shipped', name: 'Spedito' },
        { value: 'delivered', name: 'Consegnato' },
        { value: 'paymentFailed', name: 'Pagamento fallito' },
        { value: 'verifyingPayment', name: 'Verifica pagamento' },
    ];
    selectedStatus?: string;

    async ngAfterViewInit() {
        if (this.userType === 'companyManager') {
            this.orderList?.loadData(`/orders`, {companyId: this.companyId}, ( (item: any) => new Order(item)))
        } else if (this.userType === 'user') {
            this.orderList?.loadData(`/orders`, {userId: this.userId}, ( (item: any) => new Order(item)))
        } else if (this.userType === 'admin') {
            this.orderList?.loadData(`/orders`, {}, ( (item: any) => new Order(item)))
        }
    }

    constructor(public serviceInjector: Injector,
                private orderService: OrderService) {
        super(serviceInjector);
    }

    openOrderInfo(order: Order) {
        this.ngxSmartModalService.getModal('orderInfoModal').setData(order);
        this.ngxSmartModalService.getModal('orderInfoModal').open();
    }

    delete(id: string) {
        this.showQuestionMessage(() => {
            this.orderService.delete(id).subscribe((res: any) => {
                this.orderList?.reloadPage();
            });
        });
    }

    approve(id: string) {
        let order: any = { status: 'paid' }
        this.showQuestionMessage(() => {
            this.orderService.update(id, order).subscribe((res: any) => {
                if (res.success) {
                    this.showSuccessMessage('Ordine approvato!')
                } else {
                    this.showErrorMessage('Errore')
                }
                this.orderList?.reloadPage();
            });
        });
    }

    changeStatus(id: string) {
        this.orderService.update(id, { status: this.selectedStatus }).subscribe((res: any) => {
            if (res.success) {
                this.showSuccessMessage('Stato aggiornato!')
                this.ngxSmartModalService.getModal('orderInfoModal').close();
            } else {
                this.showErrorMessage('Errore')
            }
            this.orderList?.reloadPage();
        });
    }

    protected readonly moment = moment;
}
